import { NavigationItem } from '../types';
import {
  LayoutDashboard,
  Package,
  Clipboard,
  Plus,
  FileText,
  CreditCard,
  IndianRupee,
  Coins,
  BarChart2,
  Info,
  Landmark,
  Settings,
  Calculator,
  LifeBuoy,
  Link,
  ShoppingCart,
  Plug,
  Weight,
  Superscript,
  CalendarDays,
} from 'lucide-react';

export const B2B_DESKTOP_NAVIGATION: NavigationItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/b2b/dashboard',
    icon: LayoutDashboard,
  },
  {
    id: 'orders',
    label: 'Orders',
    path: '/b2b/orders',
    icon: Package,
    children: [
      {
        id: 'all-orders',
        label: 'All Orders',
        path: '/b2b/orders',
        icon: Clipboard,
      },
      {
        id: 'add-orders',
        label: 'Add Orders',
        path: '/b2b/orders/add',
        icon: Plus,
      },
    ],
  },
  {
    id: 'rate-cards',
    label: 'Rate Cards',
    path: '/b2b/rate-cards',
    icon: IndianRupee,
  },
  {
    id: 'appointment',
    label: 'Appointment',
    path: '/b2b/appointment',
    icon: CalendarDays,
  },
  {
    id: 'admin',
    label: 'Admin',
    path: '/b2b/rates',
    icon: Superscript,
    children: [
      {
        id: 'b2b-rates',
        label: 'Rates',
        path: '/b2b/rates',
        icon: Clipboard,
      },
      {
        id: 'wallet-transaction',
        label: 'Wallet Transaction',
        path: '/b2b/admin/wallet-transaction',
        icon: IndianRupee,
      },
    ],
  },
  {
    id: 'information-center',
    label: 'Information Center',
    path: '/b2b/tools/rate-calculator',
    icon: Info,
    children: [
      {
        id: 'rate-calculator',
        label: 'Rate Calculator',
        path: '/b2b/tools/rate-calculator',
        icon: Calculator,
      },
    ],
  },
  {
    id: 'finance',
    label: 'Finance',
    path: '/b2b/finance/wallet',
    icon: Landmark,
    children: [
      {
        id: 'wallet',
        label: 'Transaction',
        path: '/b2b/finance/wallet',
        icon: IndianRupee,
      },
    ],
  },
];

export const DESKTOP_NAVIGATION: NavigationItem[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    id: 'orders',
    label: 'Orders',
    path: '/orders',
    icon: Package,
    children: [
      {
        id: 'all-orders',
        label: 'All Orders',
        path: '/orders',
        icon: Clipboard,
      },
      {
        id: 'add-orders',
        label: 'Add Orders',
        path: '/orders/add',
        icon: Plus,
      },
    ],
  },

  {
    id: 'ndr',
    label: 'NDR',
    path: '/ndr',
    icon: FileText,
  },

  {
    id: 'finance',
    label: 'Finance',
    path: '/finance',
    icon: Landmark,
    children: [
      {
        id: 'wallet',
        label: 'Transaction',
        path: '/finance/wallet',
        icon: IndianRupee,
      },
      {
        id: 'invoice',
        label: 'Invoice',
        path: '/finance/invoice',
        icon: CreditCard,
      },
      {
        id: 'remittance',
        label: 'Remittance',
        path: '/finance/remittance',
        icon: Coins,
      },
    ],
  },
  // {
  //   id: 'disputes',
  //   label: 'Disputes',
  //   path: '/disputes',
  //   icon: Scale3d,
  // },
  // {
  //   id: 'weight',
  //   label: 'Weight',
  //   path: '/weight',
  //   icon: Weight,
  // },
  {
    id: 'integration',
    label: 'Integration',
    icon: Link,
    path: '/integration',
    children: [
      {
        id: 'channel',
        label: 'Channel',
        path: '/settings/channel',
        icon: ShoppingCart,
      },
      {
        id: 'open-api',
        label: 'Open API',
        path: '/open-api',
        icon: Plug,
      },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    path: '/reports',
    icon: BarChart2,
  },

  {
    id: 'support',
    label: 'Support',
    path: '/support',
    icon: LifeBuoy,
  },
  {
    id: 'settings',
    label: 'Settings',
    path: '/settings',
    icon: Settings,
    // children: [
    //   {
    //     id: "rate-calculator",
    //     label: "Rate Calculator",
    //     path: "/settings/rate-calculator",
    //     icon: Calculator,
    //   },
    // ],
  },
  {
    id: 'information-center',
    label: 'Information Center',
    path: '/Information-center',
    icon: Info,
    children: [
      {
        id: 'rate-card',
        label: 'Rate Card',
        path: '/rate-card',
        icon: Clipboard,
      },
      {
        id: 'rate-calculator',
        label: 'Rate Calculator',
        path: '/rate-calculator',
        icon: Calculator,
      },
    ],
  },
  {
    id: 'admin',
    label: 'Admin',
    path: '/admin',
    icon: Superscript,
    children: [
      {
        id: 'manage-users',
        label: 'Manage Users',
        path: '/admin/manage-users',
        icon: Clipboard,
      },
      {
        id: 'upload-pincode',
        label: 'Upload Pincode',
        path: '/admin/upload-pincode',
        icon: Plus,
      },
      {
        id: 'reco-bills',
        label: 'Reco Bills',
        path: '/admin/reco-bills',
        icon: Plus,
      },
      {
        id: 'inward-remittance',
        label: 'Inward-Remittance',
        path: '/admin/inward-remittance',
        icon: FileText,
      },
      {
        id: 'outward-remittance',
        label: 'Outward-Remittance',
        path: '/admin/outward-remittance',
        icon: FileText,
      },
      {
        id: 'shipment-charges',
        label: 'Shipment Charges',
        path: '/admin/shipment-charges',
        icon: Weight,
      },
      {
        id: 'wallet-transaction',
        label: 'Wallet Transaction',
        path: '/admin/wallet-transaction',
        icon: IndianRupee,
      },
      {
        id: 'rates',
        label: 'Rates',
        path: '/admin/rates',
        icon: Clipboard,
      },
    ],
  },
];

export const MOBILE_NAVIGATION: (NavigationItem & { inactive?: boolean })[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
  },
  {
    id: 'orders',
    label: 'Orders',
    path: '/orders',
    icon: Package,
  },
  {
    id: 'add-orders',
    label: 'Add Orders',
    path: '/orders/add',
    icon: Plus,
  },
  {
    id: 'rate-card',
    label: 'Rate Card',
    path: '/rate-card',
    icon: Clipboard,
  },
  {
    id: 'ndr',
    label: 'NDR',
    path: '/ndr',
    icon: FileText,
    inactive: false,
  },
  {
    id: 'wallet',
    label: 'Wallet',
    path: '/finance/wallet',
    icon: IndianRupee,
  },
  {
    id: 'report',
    label: 'Report',
    path: '/reports',
    icon: BarChart2,
  },
  {
    id: 'rate-calculator',
    label: 'Rate Calculator',
    path: '/rate-calculator',
    icon: Calculator,
  },
  {
    id: 'support',
    label: 'Support',
    path: '/support',
    icon: LifeBuoy,
  },
  {
    id: 'settings',
    label: 'Settings',
    path: '/settings',
    icon: Settings,
  },
];

// Admin navigation items (for drawer/sidebar admin section)
export const ADMIN_MOBILE_NAVIGATION = [
  {
    id: 'manage-users',
    label: 'Manage Users',
    path: '/admin/manage-users',
    icon: Clipboard,
  },
  {
    id: 'upload-pincode',
    label: 'Upload Pincode',
    path: '/admin/upload-pincode',
    icon: Plus,
  },
  {
    id: 'reco-bills',
    label: 'Reco Bills',
    path: '/admin/reco-bills',
    icon: Plus,
  },
  {
    id: 'inward-remittance',
    label: 'Inward-Remittance',
    path: '/admin/inward-remittance',
    icon: FileText,
  },
  {
    id: 'outward-remittance',
    label: 'Outward-Remittance',
    path: '/admin/outward-remittance',
    icon: FileText,
  },
  {
    id: 'shipment-charges',
    label: 'Shipment Charges',
    path: '/admin/shipment-charges',
    icon: Weight,
  },
  {
    id: 'wallet-transaction',
    label: 'Wallet Transaction',
    path: '/admin/wallet-transaction',
    icon: IndianRupee,
  },
  {
    id: 'rates',
    label: 'Rates',
    path: '/admin/rates',
    icon: Clipboard,
  },
];

// B2B Mobile Navigation for Regular Users
export const B2B_MOBILE_NAVIGATION: (NavigationItem & { inactive?: boolean })[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/b2b/dashboard',
    icon: LayoutDashboard,
  },
  {
    id: 'orders',
    label: 'Orders',
    path: '/b2b/orders',
    icon: Package,
  },
];

// B2B Mobile Navigation for Admin Users
export const B2B_ADMIN_MOBILE_NAVIGATION: (NavigationItem & { inactive?: boolean })[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/b2b/dashboard',
    icon: LayoutDashboard,
  },
  {
    id: 'orders',
    label: 'All Orders',
    path: '/b2b/orders',
    icon: Package,
  },
  {
    id: 'add-orders',
    label: 'Add Orders',
    path: '/b2b/orders/add',
    icon: Plus,
  },
  {
    id: 'rate-cards',
    label: 'Rate Cards',
    path: '/b2b/rate-cards',
    icon: IndianRupee,
  },
  {
    id: 'appointment',
    label: 'Appointment',
    path: '/b2b/appointment',
    icon: CalendarDays,
  },
  {
    id: 'wallet',
    label: 'Transaction',
    path: '/b2b/finance/wallet',
    icon: Landmark,
  },
  {
    id: 'b2b-rates',
    label: 'Rates',
    path: '/b2b/rates',
    icon: Clipboard,
  },
  {
    id: 'wallet-transaction',
    label: 'Wallet Transaction',
    path: '/b2b/admin/wallet-transaction',
    icon: IndianRupee,
  },
];
